import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleComment = {
  namespaced: true,

  state: {
    name: "comment",

    comments: [],
    ffcomment: "",
    signaturecomments: [],
  },

  mutations,
  getters,
  actions,
};

export default moduleComment;
